<template>
    <div class="video-page">
        <van-swipe v-if="videoTopAds.length" class="video-top-swipe" :autoplay="4000" lazy-render touchable>
            <van-swipe-item v-for="ad in videoTopAds" :key="ad.id">
                <a :href="ad.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                    <img :src="ad.pic" alt="" />
                </a>
            </van-swipe-item>
        </van-swipe>

        <van-tabs
            v-if="categories.length"
            v-model="activeTab"
            @change="onTabChange"
            swipeable
            color="#ff5a5e"
            line-width="1rem"
            line-height="0.5rem"
            background="none"
            title-inactive-color="#666"
            title-active-color="#ff5a5e"
        >
            <van-tab v-for="item in categories" :key="item.id" :title="item.name || item.classify_name || '未分类'" />
        </van-tabs>

        <div v-if="currentVideoList.length === 0" class="empty-tip">
            暂无视频数据
        </div>

        <div v-else class="video-list">
            <div v-for="item in currentVideoList" :key="item.id" class="video-item">
                <div class="video-main" @click="goPlay(item)">
                    <div class="video-cover">
                        <img v-if="item.cover" :src="item.cover" alt="" />
                        <div v-else class="cover-placeholder">视频封面</div>
                    </div>
                    <div class="video-info">
                        <h3>{{ item.title }}</h3>
                        <p>{{ item.description || '暂无简介' }}</p>
                        <div class="meta">
                            <span>{{ item.classify_name || item.category || '未分类' }}</span>
                            <span>{{ item.duration || '未知时长' }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <van-pagination
            v-if="total > pageSize"
            v-model="pageNum"
            :total-items="total"
            :items-per-page="pageSize"
            force-ellipses
            @change="onPageChange"
        />

        <div v-if="videoFloatAd" class="video-float-ad">
            <a :href="videoFloatAd.url || 'javascript:void(0)'" target="_blank" rel="noopener noreferrer">
                <img :src="videoFloatAd.pic" alt="" />
            </a>
            <div class="close" @click="videoFloatAd = null">x</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'VideoPage',
    data() {
        return {
            categories: [],
            videoList: [],
            activeTab: 0,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            videoTopAds: [],
            videoFloatAd: null
        }
    },
    computed: {
        currentVideoList() {
            return this.videoList || []
        },
        activeClassifyId() {
            const activeCategory = this.categories[this.activeTab]
            if (!activeCategory || Number(activeCategory.id) === 0) return ''
            return Number(activeCategory.id)
        },
        activeClassifyName() {
            const activeCategory = this.categories[this.activeTab]
            if (!activeCategory || Number(activeCategory.id) === 0) return ''
            return String(activeCategory.name || activeCategory.classify_name || '').trim()
        }
    },
    methods: {
        async getCategories() {
            try {
                const { data: res } = await this.$http.get('/video_classify_list')
                const list = res.data || []
                this.categories = [{ id: 0, name: '全部' }, ...list]
                this.activeTab = 0
            } catch (error) {
                this.categories = [{ id: 0, name: '全部' }]
            }
        },
        async getVideoList() {
            try {
                const { data: res } = await this.$http.get('/video_list', {
                    params: {
                        page_num: this.pageNum,
                        page_size: this.pageSize,
                        random: 1,
                        classify_id: this.activeClassifyId || '',
                        classify_name: this.activeClassifyName || ''
                    }
                })
                this.videoList = res.data || []
                this.total = Number(res.paging?.total || 0)
            } catch (error) {
                this.videoList = []
                this.total = 0
            }
        },
        onTabChange() {
            this.pageNum = 1
            this.getVideoList()
        },
        onPageChange(page) {
            this.pageNum = page
            this.getVideoList()
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        goPlay(item) {
            if (!item || !item.id) return
            this.$router.push(`/video/play/${item.id}`)
        },
        async getVideoAds() {
            try {
                const [{ data: topRes }, { data: floatRes }] = await Promise.all([
                    this.$http.get('/ad_slot_list', { params: { ad_type: 'video_top' } }),
                    this.$http.get('/ad_slot_list', { params: { ad_type: 'video_float' } })
                ])
                this.videoTopAds = topRes.data || []
                this.videoFloatAd = (floatRes.data || [])[0] || null
            } catch (error) {
                this.videoTopAds = []
                this.videoFloatAd = null
            }
        }
    },
    async created() {
        await this.getCategories()
        await this.getVideoList()
        await this.getVideoAds()
    }
}
</script>

<style lang="less" scoped>
.video-page {
    padding: 1rem;
    padding-bottom: 6rem;
}

.video-top-swipe {
    width: 100%;
    height: 7.5rem;
    margin-bottom: .8rem;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        background: #f7f8fa;
        border-radius: .5rem;
    }
}
.empty-tip {
    text-align: center;
    color: #999;
    padding: 2rem 0;
}
.video-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
}
.video-item {
    background: #fff;
    border-radius: .6rem;
    box-shadow: 0 0 10px #eee;
    overflow: hidden;
}
.video-main {
    cursor: pointer;
}
.video-cover {
    width: 100%;
    height: 12rem;
    background: #f5f5f5;
    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
.cover-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    color: #999;
}
.video-info {
    padding: .8rem;
    h3 {
        font-size: 1.2rem;
        margin-bottom: .4rem;
    }
    p {
        font-size: .9rem;
        color: #666;
        line-height: 1.5;
        margin-bottom: .6rem;
    }
}
.meta {
    display: flex;
    justify-content: space-between;
    color: #999;
    font-size: .85rem;
}
.van-pagination {
    margin-top: 1rem;
    padding: 0 0 .8rem;
}
/deep/ .van-tabs__wrap {
    margin-bottom: .5rem;
}

.video-float-ad {
    position: fixed;
    right: .4rem;
    top: 42%;
    width: 4.6rem;
    z-index: 998;
    img {
        width: 100%;
        border-radius: .5rem;
        box-shadow: 0 0 10px rgba(0, 0, 0, .22);
    }
    .close {
        text-align: center;
        color: #fff;
        font-size: .85rem;
        background: rgba(0, 0, 0, .6);
        border-radius: .3rem;
        margin-top: .2rem;
    }
}
</style>
